import React from "react";
import magA14 from "../../pdfs/MagClean A14 safe acid SDS1.pdf"

export default function MagCleanA14() {
    return(
        <div style={{height: '100vh'}}>
            <object aria-label="SDS" data={magA14} type="application/pdf" width="100%" height="100%"></object>
        </div>
    )
}